import { DataGrid } from "../../../../components";
import { Box, Card, CardContent, Chip, Divider, Typography } from "@mui/joy";

import { columnDef } from "./grid-column";
import { useProject } from "../../../../hooks/query";
import { useEffect, useState } from "react";
import { Search } from "lucide-react";

export default function ManageProject() {
    const { useList } = useProject();
    const listProjectSvc = useList();

    const [project, setProject] = useState([]);

    const fetchData = async () => {
        try {
            const response = await listProjectSvc.mutateAsync().catch(console.error);
            if (response) {
                // Filter only critical/active projects
                const critical = response.filter((p: any) => p.Status === "IN-PROGRESS" || p.Status === "NOT-STARTED");

                // Sort by earliest estimated end date
                critical.sort((a: any, b: any) => {
                    if (!a.EstimatedEndDate) return 1;
                    if (!b.EstimatedEndDate) return -1;
                    return new Date(a.EstimatedEndDate).getTime() - new Date(b.EstimatedEndDate).getTime();
                });

                // Take top 5
                setProject(critical.slice(0, 5));
            }
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <Card
            variant="plain"
            sx={{
                p: 0,
                boxShadow: "sm",
                borderRadius: "xl",
                bgcolor: "background.surface",
                border: "none",
                mt: 0,
                overflow: "hidden",
            }}
        >
            <CardContent>
                <Box p={2.5} pb={1.5}>
                    <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                        <Box>
                            <Typography level="title-lg" sx={{ fontWeight: 700, ml: 0.5 }}>
                                Critical Projects
                            </Typography>
                        </Box>
                        <Box mr={1} sx={{ opacity: 0.6 }}>
                            <Search size={18} />
                        </Box>
                    </Box>
                </Box>
                <Divider sx={{ mx: 2, mb: 0 }} />
                <Box>
                    <DataGrid gridData={project} columnDefs={columnDef} autoHeight={true} />
                </Box>
            </CardContent>
        </Card>
    );
}
